var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _CustomElement() {
    return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}

;
Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);
var Action;
(function (Action) {
    Action[Action["Alert"] = 0] = "Alert";
    Action[Action["Status"] = 1] = "Status";
    Action[Action["Hidden"] = 2] = "Hidden";
})(Action || (Action = {}));

var BasketElement = function (_CustomElement2) {
    _inherits(BasketElement, _CustomElement2);

    function BasketElement() {
        _classCallCheck(this, BasketElement);

        var _this = _possibleConstructorReturn(this, (BasketElement.__proto__ || Object.getPrototypeOf(BasketElement)).call(this));

        _this.counter = 0;
        return _this;
    }

    _createClass(BasketElement, [{
        key: "increment",
        value: function increment() {
            this.counter++;
            this.setAttribute("value", this.counter.toString());
        }
    }, {
        key: "decrement",
        value: function decrement() {
            if (this.counter > 0) {
                this.counter--;
                this.setAttribute("value", this.counter.toString());
            }
        }
        //

    }, {
        key: "_setLabelElement",
        value: function _setLabelElement() {
            this.setAttribute("aria-label", this.getAttribute("aria-label") || "basket");
        }
        // Setup role for element

    }, {
        key: "_setTypeElement",
        value: function _setTypeElement() {
            var _this2 = this;

            if (this.getAttribute("role")) return;
            if (this.getAttribute("href")) {
                this.setAttribute("role", "link");
                this.addEventListener("click", function () {
                    window.location.href = _this2.getAttribute("href");
                });
            } else {
                this.setAttribute("role", "button");
            }
        }
        // Check template

    }, {
        key: "_messageTemplate",
        value: function _messageTemplate() {
            var template = this.getAttribute("message");
            if (!template) {
                return "In basket " + this.counter;
            }
            var templateMatch = template.match("{{#}}");
            if (templateMatch) {
                return template.replace("{{#}}", "" + this.counter);
            } else {
                return template;
            }
        }
        // Control

    }, {
        key: "_controlSpan",
        value: function _controlSpan(action) {
            var el = this.querySelector("span");
            if (!el) {
                console.log("not span");
                return;
            }
            switch (action) {
                case Action.Status:
                    el.hidden = false;
                    el.setAttribute("aria-hidden", "false");
                    el.setAttribute("role", "status");
                    el.setAttribute("aria-label", this._messageTemplate());
                    el.innerHTML = "" + this.counter;
                    break;
                case Action.Alert:
                    el.hidden = false;
                    el.setAttribute("aria-hidden", "false");
                    el.setAttribute("role", "alert");
                    el.setAttribute("aria-label", this._messageTemplate());
                    el.innerHTML = "" + this.counter;
                    break;
                case Action.Hidden:
                    el.setAttribute("role", "status");
                    el.setAttribute("aria-label", this._messageTemplate());
                    el.setAttribute("aria-hidden", "true");
                    el.innerHTML = "" + this.counter;
                    el.hidden = true;
                    break;
                default:
                    el.hidden = true;
                    break;
            }
        }
    }, {
        key: "connectedCallback",
        value: function connectedCallback() {
            var value = this.getAttribute("value") || "0";
            this.counter = parseFloat(value);
            if (this.counter !== 0) this._controlSpan(Action.Status);
            this._setTypeElement();
            this._setLabelElement();
            this.setAttribute("tabindex", "0");
            if (this.counter === null) {
                var span = this.querySelector("span") || null;
                if (span !== null) span.hidden = true;
            }
        }
    }, {
        key: "disconnectedCallback",
        value: function disconnectedCallback() {}
    }, {
        key: "attributeChangedCallback",
        value: function attributeChangedCallback(name, oldValue, newValue) {
            if (name === "value") {
                if (oldValue !== newValue) {
                    if (newValue !== "0") {
                        this._controlSpan(Action.Alert);
                    } else {
                        this._controlSpan(Action.Hidden);
                    }
                }
            }
        }
    }, {
        key: "value",
        get: function get() {
            return this.counter.toString();
        },
        set: function set(value) {
            this.counter = parseFloat(value);
            this.setAttribute("value", this.counter.toString());
        }
    }], [{
        key: "observedAttributes",
        get: function get() {
            return ["value"];
        }
    }]);

    return BasketElement;
}(_CustomElement);

if (!window.customElements.get("basket-element")) {
    window.BasketElement = BasketElement;
    window.customElements.define("basket-element", BasketElement);
}
export default BasketElement;
